import { ConfigModel } from './config';

export class MenuConfig implements ConfigModel {
  public config: any = {};

  constructor(config: any = null) {
    if (config) {
      this.config = config;
    }
  }
}
